// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.card_card-container-overlay_HOWEv {
  position: fixed;
  pointer-events: none;
  z-index: 480;
}

.card_card-container_Cs0OY {
  position: absolute;
  pointer-events: auto;
  z-index: 480;
  margin: 0.5rem 2rem;
  min-width: 468px;
}

.card_left-card_ULEGo,
.card_right-card_OO7xe {
  height: 90%;
  position: absolute;
  top: 5%;
  background: var(--ui-white);
  border: 1px solid var(--ui-tertiary);
  width: 0.75rem;
  z-index: 10;
  opacity: 0.9;
  overflow: hidden;
}

.card_left-card_ULEGo {
  left: -0.75rem;
  border-right: 0;
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.card_right-card_OO7xe {
  right: -0.75rem;
  border-left: 0;
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.card_left-card_ULEGo::after,
.card_right-card_OO7xe::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 2.5rem;
  width: 100%;
  background: var(--extensions-primary);
}

.card_left-button_cGYrp,
.card_right-button_iYn5S {
  position: absolute;
  top: 50%;
  margin-top: -15px;
  z-index: 20;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  cursor: pointer;
  background: var(--extensions-primary);
  box-shadow: 0 0 0 4px var(--extensions-transparent);
  height: 44px;
  width: 44px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.25s ease;
}

.card_left-button_cGYrp:hover,
.card_right-button_iYn5S:hover {
  box-shadow: 0 0 0 6px var(--extensions-transparent);
  transform: scale(1.125);
}

.card_left-button_cGYrp img,
.card_right-button_iYn5S img {
  width: 1.75rem;
}

.card_left-button_cGYrp {
  left: -27px;
}

.card_right-button_iYn5S {
  right: -27px;
}

.card_card_wHoAD {
  border: 1px solid var(--ui-tertiary);
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  cursor: move;
  z-index: 20;
  overflow: hidden;
  box-shadow: 0px 5px 25px 5px var(--shadow);
  align-items: center;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.card_header-buttons_Ms0WR {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: var(--extensions-primary);
  border-bottom: 1px solid var(--extensions-tertiary);
  font-size: 0.625rem;
  font-weight: bold;
}

.card_header-buttons-hidden_RyHRA {
  border-bottom: 0px;
}

.card_header-buttons-right_VPQKd {
  display: flex;
  flex-direction: row;
}

.card_header-buttons_Ms0WR img {
  margin-bottom: 2px;
}

.card_shrink-expand-button_r5Hjj {
  cursor: pointer;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
}

.card_shrink-expand-button_r5Hjj:hover,
.card_all-button_drR8x:hover {
  background-color: var(--ui-black-transparent);
}

.card_remove-button_B_2wK,
.card_all-button_drR8x {
  cursor: pointer;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
}

.card_remove-button_B_2wK:hover,
.card_all-button_drR8x:hover {
  background-color: var(--ui-black-transparent);
}

.card_step-title_mb25I {
  font-size: 0.9rem;
  margin: 0.9rem;
  text-align: center;
  font-weight: bold;
  color: var(--text-primary);
}

.card_step-body_k2wJJ {
  width: 100%;
  background: var(--ui-white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;

  /* Min height prevents layout changing when images change */
  min-height: 256px;
}

.card_step-video_ENQHM {
  height: 256px;
}

.card_step-image_AcHFk {
  max-width: 450px;
  max-height: 200px;
  object-fit: contain;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  overflow: hidden;
  margin: 0 0.5rem 0.5rem;
}

.card_decks_YZrRK {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0 1rem 0.5rem;
}

.card_deck_rUBeV {
  display: flex;
  flex-direction: column;
  margin: 0 8px 8px;
  cursor: pointer;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0.25rem;
  overflow: hidden;
}

.card_deck-image_P53kP {
  width: 200px;
  height: 100px;
  object-fit: cover;
}

.card_deck-name_aivP5 {
  color: var(--looks-secondary);
  font-weight: bold;
  font-size: 0.85rem;
  margin: 0.625rem 0px;
  text-align: center;
  font-weight: bold;
  text-align: center;
  max-width: 200px;
}

.card_help-icon_LELqy {
  height: 1.25rem;
}

.card_close-icon_ViJ3D {
  height: 1.25rem;
  margin: 0.125rem 0; /* To offset the .25rem difference in icon size */
}

[dir='ltr'] .card_help-icon_LELqy {
  margin-right: 0.25rem;
}

[dir='rtl'] .card_help-icon_LELqy {
  margin-left: 0.25rem;
}

[dir='ltr'] .card_close-icon_ViJ3D {
  margin-left: 0.25rem;
}

[dir='rtl'] .card_close-icon_ViJ3D {
  margin-right: 0.25rem;
}

.card_see-all_I8clp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  padding: 0.5rem;
}

.card_see-all-button_AWMlV {
  cursor: pointer;
  padding: 0.5rem 1rem;
  background-color: var(--looks-secondary);
  color: white;
  font-weight: bold;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  color: var(--ui-white);
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1rem;
  text-align: center;
}

[dir='ltr'] .card_see-all-button_AWMlV img {
  margin-left: 0.5rem;
}

[dir='rtl'] .card_see-all-button_AWMlV img {
  margin-right: 0.5rem;
}

.card_steps-list_XaR70 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.card_active-step-pip_pv1GI,
.card_inactiveStepPip_sFcGX {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 0.25rem;
  border-radius: 100%;
  background: var(--ui-white-transparent);
}

.card_active-step-pip_pv1GI {
  background: var(--ui-white);
  box-shadow: 0px 0px 0px 2px var(--shadow);
}

.card_hidden_SU1jH {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/card.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,2BAA2B;EAC3B,oCAAoC;EACpC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;EACf,qCAAqC;EACrC,mDAAmD;EACnD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,mDAAmD;EACnD,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;;EAElB,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.card-container-overlay {\n  position: fixed;\n  pointer-events: none;\n  z-index: 480;\n}\n\n.card-container {\n  position: absolute;\n  pointer-events: auto;\n  z-index: 480;\n  margin: 0.5rem 2rem;\n  min-width: 468px;\n}\n\n.left-card,\n.right-card {\n  height: 90%;\n  position: absolute;\n  top: 5%;\n  background: var(--ui-white);\n  border: 1px solid var(--ui-tertiary);\n  width: 0.75rem;\n  z-index: 10;\n  opacity: 0.9;\n  overflow: hidden;\n}\n\n.left-card {\n  left: -0.75rem;\n  border-right: 0;\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.right-card {\n  right: -0.75rem;\n  border-left: 0;\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n\n.left-card::after,\n.right-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 2.5rem;\n  width: 100%;\n  background: var(--extensions-primary);\n}\n\n.left-button,\n.right-button {\n  position: absolute;\n  top: 50%;\n  margin-top: -15px;\n  z-index: 20;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  background: var(--extensions-primary);\n  box-shadow: 0 0 0 4px var(--extensions-transparent);\n  height: 44px;\n  width: 44px;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.25s ease;\n}\n\n.left-button:hover,\n.right-button:hover {\n  box-shadow: 0 0 0 6px var(--extensions-transparent);\n  transform: scale(1.125);\n}\n\n.left-button img,\n.right-button img {\n  width: 1.75rem;\n}\n\n.left-button {\n  left: -27px;\n}\n\n.right-button {\n  right: -27px;\n}\n\n.card {\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  cursor: move;\n  z-index: 20;\n  overflow: hidden;\n  box-shadow: 0px 5px 25px 5px var(--shadow);\n  align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n.header-buttons {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--extensions-primary);\n  border-bottom: 1px solid var(--extensions-tertiary);\n  font-size: 0.625rem;\n  font-weight: bold;\n}\n\n.header-buttons-hidden {\n  border-bottom: 0px;\n}\n\n.header-buttons-right {\n  display: flex;\n  flex-direction: row;\n}\n\n.header-buttons img {\n  margin-bottom: 2px;\n}\n\n.shrink-expand-button {\n  cursor: pointer;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0.75rem;\n}\n\n.shrink-expand-button:hover,\n.all-button:hover {\n  background-color: var(--ui-black-transparent);\n}\n\n.remove-button,\n.all-button {\n  cursor: pointer;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0.75rem;\n}\n\n.remove-button:hover,\n.all-button:hover {\n  background-color: var(--ui-black-transparent);\n}\n\n.step-title {\n  font-size: 0.9rem;\n  margin: 0.9rem;\n  text-align: center;\n  font-weight: bold;\n  color: var(--text-primary);\n}\n\n.step-body {\n  width: 100%;\n  background: var(--ui-white);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  text-align: center;\n\n  /* Min height prevents layout changing when images change */\n  min-height: 256px;\n}\n\n.step-video {\n  height: 256px;\n}\n\n.step-image {\n  max-width: 450px;\n  max-height: 200px;\n  object-fit: contain;\n  background: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin: 0 0.5rem 0.5rem;\n}\n\n.decks {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  padding: 0 1rem 0.5rem;\n}\n\n.deck {\n  display: flex;\n  flex-direction: column;\n  margin: 0 8px 8px;\n  cursor: pointer;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0.25rem;\n  overflow: hidden;\n}\n\n.deck-image {\n  width: 200px;\n  height: 100px;\n  object-fit: cover;\n}\n\n.deck-name {\n  color: var(--looks-secondary);\n  font-weight: bold;\n  font-size: 0.85rem;\n  margin: 0.625rem 0px;\n  text-align: center;\n  font-weight: bold;\n  text-align: center;\n  max-width: 200px;\n}\n\n.help-icon {\n  height: 1.25rem;\n}\n\n.close-icon {\n  height: 1.25rem;\n  margin: 0.125rem 0; /* To offset the .25rem difference in icon size */\n}\n\n[dir='ltr'] .help-icon {\n  margin-right: 0.25rem;\n}\n\n[dir='rtl'] .help-icon {\n  margin-left: 0.25rem;\n}\n\n[dir='ltr'] .close-icon {\n  margin-left: 0.25rem;\n}\n\n[dir='rtl'] .close-icon {\n  margin-right: 0.25rem;\n}\n\n.see-all {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  padding: 0.5rem;\n}\n\n.see-all-button {\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  background-color: var(--looks-secondary);\n  color: white;\n  font-weight: bold;\n  border-radius: 0.25rem;\n  display: flex;\n  align-items: center;\n  color: var(--ui-white);\n  font-size: 0.75rem;\n  font-weight: bold;\n  line-height: 1rem;\n  text-align: center;\n}\n\n[dir='ltr'] .see-all-button img {\n  margin-left: 0.5rem;\n}\n\n[dir='rtl'] .see-all-button img {\n  margin-right: 0.5rem;\n}\n\n.steps-list {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.active-step-pip,\n.inactiveStepPip {\n  width: 0.5rem;\n  height: 0.5rem;\n  margin: 0 0.25rem;\n  border-radius: 100%;\n  background: var(--ui-white-transparent);\n}\n\n.active-step-pip {\n  background: var(--ui-white);\n  box-shadow: 0px 0px 0px 2px var(--shadow);\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-container-overlay": `card_card-container-overlay_HOWEv`,
	"cardContainerOverlay": `card_card-container-overlay_HOWEv`,
	"card-container": `card_card-container_Cs0OY`,
	"cardContainer": `card_card-container_Cs0OY`,
	"left-card": `card_left-card_ULEGo`,
	"leftCard": `card_left-card_ULEGo`,
	"right-card": `card_right-card_OO7xe`,
	"rightCard": `card_right-card_OO7xe`,
	"left-button": `card_left-button_cGYrp`,
	"leftButton": `card_left-button_cGYrp`,
	"right-button": `card_right-button_iYn5S`,
	"rightButton": `card_right-button_iYn5S`,
	"card": `card_card_wHoAD`,
	"header-buttons": `card_header-buttons_Ms0WR`,
	"headerButtons": `card_header-buttons_Ms0WR`,
	"header-buttons-hidden": `card_header-buttons-hidden_RyHRA`,
	"headerButtonsHidden": `card_header-buttons-hidden_RyHRA`,
	"header-buttons-right": `card_header-buttons-right_VPQKd`,
	"headerButtonsRight": `card_header-buttons-right_VPQKd`,
	"shrink-expand-button": `card_shrink-expand-button_r5Hjj`,
	"shrinkExpandButton": `card_shrink-expand-button_r5Hjj`,
	"all-button": `card_all-button_drR8x`,
	"allButton": `card_all-button_drR8x`,
	"remove-button": `card_remove-button_B_2wK`,
	"removeButton": `card_remove-button_B_2wK`,
	"step-title": `card_step-title_mb25I`,
	"stepTitle": `card_step-title_mb25I`,
	"step-body": `card_step-body_k2wJJ`,
	"stepBody": `card_step-body_k2wJJ`,
	"step-video": `card_step-video_ENQHM`,
	"stepVideo": `card_step-video_ENQHM`,
	"step-image": `card_step-image_AcHFk`,
	"stepImage": `card_step-image_AcHFk`,
	"decks": `card_decks_YZrRK`,
	"deck": `card_deck_rUBeV`,
	"deck-image": `card_deck-image_P53kP`,
	"deckImage": `card_deck-image_P53kP`,
	"deck-name": `card_deck-name_aivP5`,
	"deckName": `card_deck-name_aivP5`,
	"help-icon": `card_help-icon_LELqy`,
	"helpIcon": `card_help-icon_LELqy`,
	"close-icon": `card_close-icon_ViJ3D`,
	"closeIcon": `card_close-icon_ViJ3D`,
	"see-all": `card_see-all_I8clp`,
	"seeAll": `card_see-all_I8clp`,
	"see-all-button": `card_see-all-button_AWMlV`,
	"seeAllButton": `card_see-all-button_AWMlV`,
	"steps-list": `card_steps-list_XaR70`,
	"stepsList": `card_steps-list_XaR70`,
	"active-step-pip": `card_active-step-pip_pv1GI`,
	"activeStepPip": `card_active-step-pip_pv1GI`,
	"inactiveStepPip": `card_inactiveStepPip_sFcGX`,
	"hidden": `card_hidden_SU1jH`
};
export default ___CSS_LOADER_EXPORT___;
